export default function timeToDecimal(time) {
  if (!time) {
    return '';
  }
  const hhmm = time.split(':');
  return (parseInt(hhmm[0], 10) + hhmm[1] / 60).toFixed(2);
}
